import { DetailUser } from "./view/detailUser";

export const userRoutes = [
    {
        path: 'user',
        element: <DetailUser />
    }
];